// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1iw1r","inputWrap":"styles_inputWrap__3Poah","input":"styles_input__2UOgs"};